import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Payment.css';
import { useHistory, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function PaymentSuccess() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { paymentId } = useParams();
    

    return (
        <>
            <div className="container-fluid event-grid">
                <Helmet>
                    <meta name="description" content="Please contact us using this form if you face any problem. Our team will help you in any case..." />
                    <title>Payment Success | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="col-md-10 mx-auto about__us text-left">
                    <div className="container">
                        <div className="printer-top"></div>
                            
                        <div className="paper-container">
                            <div className="printer-bottom"></div>
                            <div className="paper">
                                <div className="main-contents">
                                    <div className="success-icon">&#10004;</div>
                                    <div className="success-title">
                                        Payment Complete
                                    </div>
                                    <div className="success-description">
                                        Kaipsool Pharmatech not only serves as a pharmaceutical information platform but also lists sports tournaments.
                                    </div>
                                    {paymentId && <div className="order-details">
                                        <div className="order-number-label">Payment Id</div>
                                        <div className="order-number">{paymentId}</div>
                                    </div>}
                                    <div className="order-footer">Thank you!</div>
                                </div>
                                <div className="jagged-edge"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PaymentSuccess
